export default __webpack_public_path__ + "static/media/IR2.508c8468.wav";